import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const DefaultCustomItemOptions = {
	[PbProductType.Disposition]: {
		[PbSubcategory.DispositionFullServiceBurial]: [],
		[PbSubcategory.DispositionFullServiceCremation]: [],
		[PbSubcategory.DispositionDirectBurial]: [],
		[PbSubcategory.DispositionDirectCremation]: [],
		[PbSubcategory.DispositionMemorialServiceCremation]: [],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Package]: {
		[PbSubcategory.PackageBurial]: [],
		[PbSubcategory.Cremation]: [],
	},
	[PbProductType.Service]: {
		[PbSubcategory.ServiceBasicServicesOfFDAndStaff]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceEmbalming]: [],
		[PbSubcategory.ServiceRefrigeration]: [
			{
				prop: 'numberOfDays',
				label: 'Number of Days',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceOtherBodyPreparation]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceVisitationViewing]: [
			{
				prop: 'numberOfDays',
				label: 'Number of Days',
				type: 'number',
				required: false,
			},
			{
				prop: 'amountPerDay',
				label: 'Amount Per Day',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceFuneralMemorial]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceGravesideService]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceCremationService]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceForwardingRemains]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.ServiceReceivingRemains]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Transportation]: {
		[PbSubcategory.TransportationTransfer]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationHearse]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
			{
				prop: 'specificMileAllotment',
				label: 'Specific Mile Allotment',
				type: 'text',
				required: false,
			},
			{
				prop: 'amountPerMile',
				label: 'Amount Per Mile',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationFamilyCarLimo]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
			{
				prop: 'specificMileAllotment',
				label: 'Specific Mile Allotment',
				type: 'text',
				required: false,
			},
			{
				prop: 'amountPerMile',
				label: 'Amount Per Mile',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationUtilityVehicleVan]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Merchandise]: {
		[PbSubcategory.MerchandiseCasket]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'interiorDescription',
				label: 'Interior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseOuterBurialContainer]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseUrn]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseRegisterBookMemorialFoldersAckCards]: [],
		[PbSubcategory.MerchandiseClothing]: [],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.CashAdvance]: {
		[PbSubcategory.CashAdvanceDeathCertificates]: [
			{ prop: 'quantity', label: 'Quantity', type: 'text', required: false },
			{
				prop: 'amountPerDeathCertificate',
				label: 'Amount Per Death Certificate',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceObituary]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceFlowers]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'flowersType',
				label: 'Flowers Type',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceHairdresser]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceClothing]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceClergyHonorarium]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceMusicianVocalist]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceMusic]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CashAdvanceCremationServices]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.FamilyTravel]: {
		[PbSubcategory.FamilyTravelAirfare]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.FamilyTravelLodging]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Cemetery]: {
		[PbSubcategory.CemeteryEscorts]: [
			{
				prop: 'shortDescription',
				label: 'Escorts Number',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CemeteryInterment]: [
			{
				prop: 'weekdayOpeningClosingCost',
				label: 'Weekday Opening & Closing Cost',
				type: 'text',
				required: false,
			},
			{
				prop: 'weekendHolidayOpeningClosingCost',
				label: 'Weekend/Holiday Opening & Closing Cost',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CemeterySpaces]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CemeteryPlot]: [],
		[PbSubcategory.CemeteryMausoleum]: [],
		[PbSubcategory.CemeteryColumbarium]: [],
		[PbSubcategory.CemeteryVaultSetting]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.CemeteryMonumentMarker]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Afterward]: {
		[PbSubcategory.AfterwardLocation]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.AfterwardCatering]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.AfterwardOther]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Other]: {
		[PbSubcategory.OtherFamilyAllowance]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.OtherSalesTax]: [
			{
				prop: 'shortDescription',
				label: 'Percentage',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other2]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
}
